import React, { useContext, useEffect, useRef } from "react";
import WindowLevel from "../../../../../components/SVGComponents/Tools/WindowLevel";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import {
  WINDOW_LEVEL_MODALITY_LIST,
  WINDOW_LEVEL_PRESETS,
} from "../../../../../constants/Constants";
import DropDown from "../../../../../components/SVGComponents/Tools/DropDown";
import { useState } from "react";
import WindowLevelPresets from "./WindowLevelPresets";
import { StackScrollTool, WindowLevelTool } from "@cornerstonejs/tools";
import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import "../../../styles/styles.css";
import themeContext from "../../../../../context/theme/ThemeContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../../helpers/Amplitude";
import userContext from "../../../../../context/users/UserContext";
import { toolTipStyles } from "../../../styles/styles";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";

const WindowLevelToolComponent = ({ toolName, tool }) => {
  const { theme } = useContext(themeContext);
  const { studyModality } = useContext(studyviewerContext);
  const { activeModality } = useContext(ThumbnailContext);
  const { username } = useContext(userContext);
  const dropDownRef = useRef(null);
  const [showDropDown, setShowDropDown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [dropDownHovered, setDropDownHovered] = useState(false);
  const { isMPRActive, activeMPRTool,handleDefaultToolChange, setBoundingBoxMode , setIsCropEnable} = useContext(ViewportContext);
  const { t } = useTranslation();
  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleMouseOver = () => {
    setHovered(true);
  };
  const { activeTool, setActiveTool, setPreviousActiveTool } =
    useContext(ViewportContext);

  const handleDropDownClick = () => {
    setShowDropDown(!showDropDown);
    // changeActiveTool(toolName);
  };

  const changeActiveTool = (toolName) => {
    setBoundingBoxMode(false);

    setIsCropEnable(false);
    if (
      activeTool != WindowLevelTool.toolName &&
      WINDOW_LEVEL_MODALITY_LIST.includes(activeModality)
    ) {
      setPreviousActiveTool(activeTool);
      setActiveTool(WindowLevelTool.toolName);
      if (tool.isEvent) {
        logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
      }
    } else if (
      !WINDOW_LEVEL_MODALITY_LIST.includes(activeModality) &&
      activeTool !== toolName
    ) {
      setPreviousActiveTool(activeTool);
      setActiveTool(toolName);
      if (tool.isEvent) {
        logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
      }
    } else if (activeTool == toolName) {
      setPreviousActiveTool(activeTool);
      // setActiveTool(StackScrollTool.toolName);
      handleDefaultToolChange();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${isMobile ? "60px" : "100%"}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: isMobile ? "65%" : "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CustomToolTipHost
                delay={TooltipDelay.zero}
                id={"window-level"}
                directionalHint={DirectionalHint.bottom}
                styles={toolTipStyles}
                content={isMobile ? "" : t("viewer.tools.window")}
                className={"myToolTip"}
              >
                <div
                  className={isMobile ? "highlight-tool-mobile" : "highlight-tool"}
                  style={{
                    width: `${
                      WINDOW_LEVEL_MODALITY_LIST.includes(activeModality)
                        ? "45px"
                        : "35px"
                    }`,
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={() => changeActiveTool(toolName)}
                    onMouseOver={handleMouseOver}
                    onMouseLeave={handleMouseLeave}
                  >
                    <WindowLevel
                      color={
                        (isMPRActive && activeMPRTool === toolName) ||
                        (!isMPRActive && activeTool === toolName) ||
                        hovered
                          ? theme.palette.activeTool
                          : theme.palette.inactiveTool
                      }
                    />
                  </div>
                  {WINDOW_LEVEL_MODALITY_LIST.includes(activeModality) && (
                    <div
                      style={{
                        marginLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                        height: "100%"
                      }}
                      onClick={handleDropDownClick}
                      onMouseOver={() => setDropDownHovered(true)}
                      onMouseLeave={() => setDropDownHovered(false)}
                    >
                      <DropDown
                        color={
                          dropDownHovered || hovered
                            ? theme.palette.activeTool
                            : theme.palette.inactiveTool
                        }
                      />
                    </div>
                  )}
                </div>
              </CustomToolTipHost>
            </div>
            {isMobile && (
              <span
                style={{
                  fontSize: "9px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  //color: "#FFFFFF",
                  //color: "var(--navbar-header-popup-color-txt)",
                  color: "var(--mobile-color-txt)",
                }}
              >
                {t("viewer.tools.window")}
              </span>
            )}
          </div>
        </div>
        <div
          className={
            isMobile ? "dropdow-bottom-position viewer-tool-more-dropdown" : "dropdow-top-position viewer-tool-more-dropdown"
          }
          ref={dropDownRef}
          style={{
            display: `${
              showDropDown &&
              WINDOW_LEVEL_MODALITY_LIST.includes(activeModality)
                ? "flex"
                : "none"
            }`,
            flexDirection: "column",
            position: "absolute",
            // top : window.innerHeight * 0.075,
            zIndex: "999",
            // backgroundColor: "#201F1E",
            boxShadow:
              "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
            borderRadius: "5px",
            paddingLeft: "10px",
            paddingRight: "20px",
          }}
        >
          {WINDOW_LEVEL_PRESETS.map((wl, index) => {
            return (
              <div key={index}>
                <WindowLevelPresets wl={wl} setShowDropDown={setShowDropDown} />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default WindowLevelToolComponent;
